export const UploadSuccess = () => (
    <>File uploaded successfully!</>
  );
  
  export const UploadFailed = () => (
    <>Upload failed. Please try again later.</>
  );
  
  export const DocumentDeleted = ({ docType }) => (
    <>{docType} deleted successfully.</>
  );
  
  export const DeletionFailed = ({ page }) => (
    <>{page} Failed to delete. Please try again.</>
  );
  